import React, { useEffect, useRef, useState } from "react";
import { useSortBy } from "react-instantsearch";
import styles from "../SortComp/sortBy.module.scss";
import { collectionPath } from "../collection-utils";
import { useRouter } from "next/compat/router";
import { reportError } from "@/helpers/errorHelper";
import { isPWA } from "@/helpers/generalHelper";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { useSelector } from "react-redux";

const CustomSortBy = (props) => {
  const sortByWrapper = useRef();
  const [defaultFilter, setDefaultFilter] = useState();
  const router = useRouter();
  const isMobile = useMediaQuery("(max-width: 767px)");
  // handles dropdown
  const handleDropdown = () => {
    let target = sortByWrapper.current
    target.classList.toggle(`${styles.active}`);
    if(isMobile) {
      document.body.classList.toggle(`sort_open`);
    }
  }
  const accountSidebarOpen = useSelector((state) => state.loginUser.open_account_sidebar);

  const serverPath = props?.serverPath.split("/")[1]

  const getSortingOptionsByServerPath = () => {
    switch (serverPath) {
      case collectionPath[2]: // check if the server path is "/new-arrivals"
        return [
          { label: "Featured", value: `${process.env.SHOPIFY_PRIMARY_INDEX}` },
          { label: "Price High to Low", value: `${process.env.SHOPIFY_PRICE_DESC_INDEX}` },
          { label: "Price Low to High", value: `${process.env.SHOPIFY_PRICE_ASC_INDEX}` },
        ]
      default:
        return [
          { label: "Featured", value: `${process.env.SHOPIFY_PRIMARY_INDEX}` },
          { label: "Newest First", value: `${process.env.SHOPIFY_NEWEST_FIRST_INDEX}` },
          { label: "Price High to Low", value: `${process.env.SHOPIFY_PRICE_DESC_INDEX}` },
          { label: "Price Low to High", value: `${process.env.SHOPIFY_PRICE_ASC_INDEX}` },
        ]
    }
  }


  // sorting attributes
  const { options, refine } = useSortBy({
    items: getSortingOptionsByServerPath(),
  });

  // checking which value is selected from onclick
  function refinedValue(value) {
    setDefaultFilter(value);
  }

  useEffect(() => {
    try {
      // Set defaultFilter from query parameter on component render
      let storedSortFilter = "";
      // To handle sortBy filter if index is different
      Object.keys(router?.query).map((key)=>{
        if(key?.includes("[sortBy]")){
          storedSortFilter=router.query[key];
        }
      })
      switch (storedSortFilter) {
        case `${process.env.SHOPIFY_NEWEST_FIRST_INDEX}`:
          setDefaultFilter('Newest First');
          break;
        case `${process.env.SHOPIFY_PRICE_DESC_INDEX}`:
          setDefaultFilter('Price High to Low');
          break;
        case `${process.env.SHOPIFY_PRICE_ASC_INDEX}`:
          setDefaultFilter('Price Low to High');
          break;
        default:
          setDefaultFilter('Featured');
      } 
    } catch (error) {
      reportError("Error in fetching the Sort title")
      reportError(error)
    }
  }, [router]);

  return (
    <div className={`sort-by-txt ${styles.sort_by_wrapper}`} ref={sortByWrapper} >
      <div className={`${styles.sort_by_backdrop}`} onClick={handleDropdown}></div>
      <div className={`${styles.sort_by_header} large-md normal-sm small-xs light-md`} onClick={handleDropdown} id="sort-handle-button-desktop">
        Sort by<span className={`${styles.xs_hide}`}>:</span>
        <div className={`small-md small-sm ${styles.sort__active_cta}`}><span className={`${styles.active__cta_title}`}>{defaultFilter === undefined ? "Featured" : defaultFilter}</span>
          <div className={`py-1 ${styles.down_arrow}`}>
            <svg width="17" height="10" viewBox="0 0 17 10" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(-1 0 0 1 15.7 1) matrix(-1 0 0 1 14 0)" stroke="#2F2F30" strokeWidth="1.4" fill="none" fillRule="evenodd" strokeLinecap="round"><path transform="matrix(0 1 1 0 -.5 .5)" d="M-.5.5 7.5 7.5" /><path transform="matrix(0 1 1 0 6.4 -6.4)" d="M6.4 7.5 14.4.5" /></g></svg>
          </div>
        </div>
      </div>
      <div className={`${styles.sort_dropdown} ${isPWA()? styles.pwa_sort_dropdown:""} ${accountSidebarOpen && !isMobile ? "" : "z-index-100"}`}>
        <div className={`${styles.sort_sub_header}`} id="sort-handle-button-mobile" onClick={handleDropdown}>
          <span className="small-xs">Sort by</span>
          <div className={`py-1 ${styles.down_arrow} ${styles.mob_down_arrow}`}>
            <svg width="17" height="10" viewBox="0 0 17 10" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(-1 0 0 1 15.7 1) matrix(-1 0 0 1 14 0)" stroke="#2F2F30" strokeWidth="1.4" fill="none" fillRule="evenodd" strokeLinecap="round"><path transform="matrix(0 1 1 0 -.5 .5)" d="M-.5.5 7.5 7.5" /><path transform="matrix(0 1 1 0 6.4 -6.4)" d="M6.4 7.5 14.4.5" /></g></svg>
          </div>
        </div>
        <ul className={`${styles.sort__dropdonw_wrapper}`} id={`sort-ul-tag`}>
          {options.map(item => (
            <li key={item.value} id={`sort-li-${item.value}`}>
              <a
                className={`exclude-pwa-loader x-small-md x-small-sm small-xs ${styles.sort__dropdown_cta}${item.isRefined ? ` ${styles.active__cta}` : ''}`}
                onClick={event => {
                  handleDropdown();
                  event.preventDefault();
                  props.dispatch({ type: "GO_TO_FIRST_PAGE" });
                  refine(item.value);
                  refinedValue(item.label);
                }}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
};
export default CustomSortBy;
